import React, { Component } from 'react';
import { BrowserRouter, Switch, Route,Redirect } from 'react-router-dom';
import '../../Style/App.css';
import { connect } from 'react-redux';
import * as repositoryActions from '../../Store/Actions/repositoryActions';
import * as sidebarActions from '../../Store/Actions/sidebarActions';
import { library } from '@fortawesome/fontawesome-svg-core'; //svg core
import { makeStyles } from '@material-ui/core/styles';

//Components, Containers, Views
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import SideBar from '../Containers/sideBar';
import View404 from '../Views/404';
import Login from '../Views/login';
import Homepage from '../Views/homepage';
import View from '../Views/genericView';
import Footer from '../Containers/footer';
import SideBarItem from '../Components/SidebarItem';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

// Icons
import {faTable,faEuroSign,faSortAmountDownAlt,faSortAmountUp, faMinus,faPlus,faLightbulb,faCompressArrowsAlt,faMoon,faExpandArrowsAlt, faAngleDoubleRight, faAngleDoubleLeft,faQuestionCircle,faSkullCrossbones,faBug,faBook,faCheck,faCheckSquare, faCoffee, faGlobeEurope, faIdBadge, faFlag, faUniversity, faFileDownload, faListUl, faCog, faEllipsisV, faHome, faTrash, faTimesCircle, faPlusCircle, faMinusCircle, faEraser,faCaretLeft, faCaretRight, faPen, faCaretDown, faHistory, faSpinner, faInfoCircle, faSyncAlt } from '@fortawesome/free-solid-svg-icons'; // solid Icons
library.add(faTable,faEuroSign,faSortAmountDownAlt, faSortAmountUp,faMinus,faPlus,faLightbulb,faCompressArrowsAlt,faMoon,faExpandArrowsAlt,faAngleDoubleRight,faAngleDoubleLeft,faQuestionCircle, faSkullCrossbones,faBug,faBook,faCheck,faCheckSquare,faCoffee, faGlobeEurope, faIdBadge,faPen, faFlag, faUniversity,faFileDownload,faCaretRight,faCaretLeft, faListUl,faCog, faEllipsisV, faHome,faTrash, faTimesCircle, faPlusCircle, faMinusCircle, faEraser, faCaretDown, faHistory,faSpinner,faInfoCircle,faSyncAlt)



class App extends Component {
  

  buildingFunction = ()=> {
    return [];
  }
  resolveClasses = ()=>{
    var classes = "App ";
    if(this.props.presentationMode){
      classes = classes+"slideShowMode ";
    }    
    if(this.props.nightMode){
      classes = classes+"darkMode ";
    }
    return classes
  }

  componentDidMount = ()=>{
    this.props.openSession(this.props);
  }
  componentWillUnmount() {
  }

  handleLeavePage = (event) => {
    //SEND close session
    event.returnValue = 'Session wil be disconnected';
  };


  BuildSidebar = ()=>{
    var views = this.props.menuList.map(function(item, i){
      return (item.ITEM);
    });
    views = [...new Set(views.filter(item=>item !== null))];
    

    var viewsItem = views.map((item,i)=>{
      var menu = item;
      var subItems = this.props.menuList.filter(subItem=>subItem.ITEM === menu).map(function(item, i){
        return (item.SUBITEM);
      });
      return(<SideBarItem key={i} View={item} URI="/View" SubItems={subItems}></SideBarItem>)
    }
    );

    return (
    <SideBar>
      <SideBarItem  View="Home" URI="/" SubItems={
        [
          "Dashboard"
        ]
      }></SideBarItem>
      {viewsItem}
    </SideBar>
    )
  }

  toggleDrawer = ()=>{
    this.props.toggleSidebar(this.props);
  }
  onClickLogout = (e)=>{
    e.preventDefault();
    //console.log("lougout");
    this.props.logoutReturn();
    this.props.openSession(this.props);
    this.props.updateActiveMenu("/Login");
    this.props.updateActiveURI("/Login");
    
  }

  updateClientActive = (e) =>{
    if(e !== null)
    {
      this.props.changeClientActive(e.LINK_DB);
      this.props.fullScopeData(this.props.fullScope);
    }    
  }

  render() {
    const classes = makeStyles(theme => ({
      root: {
        flexGrow: 1,
      },
      menuButton: {
        marginRight: theme.spacing(2),
      },
      title: {
        flexGrow: 1,
      },
    }));
    var appClasses = this.resolveClasses();
    var Sidebar = this.BuildSidebar();
    var Clients = this.props.clientList;
    // var list = ["A2","B2","C3","1A","A1","B1","D1","A0","A2","B2","C3","1A","A1","B1","D1","A0"];
    // list.sort(
    //   ( a, b )=> {
    //     if (a<b)
    //       return -1;
    //     if (a<b)
    //       return 1;
    //     // a doit être égal à b
    //     return 0;
    //   }
    // );
    // console.log("sorting",list);

    return (
      <BrowserRouter>
        <div className={appClasses}>
          <AppBar position="static">
            <Toolbar>
              <IconButton edge="start" className={classes.menuButton} onClick={this.props.toggleSidebar} color="inherit" aria-label="menu">
              {this.props.isLogged?<MenuIcon />:null}
              </IconButton>
              <Typography variant="h6" className={classes.title}>
                AVAFIN
              </Typography>
              <div className="Header-spacer">
              {Clients.length>0 && this.props.formatedData.length>0? <Autocomplete
                id="combo-box"
                options={Clients}
                onChange={(event, value) => this.updateClientActive(value)}
                getOptionLabel={option => option.LINK_DB + " - " + option.K02}
                defaultValue={Clients[0]}
                style={{ width: 300 }}
                renderInput={params => (
                  <TextField {...params} label="Client" variant="outlined" fullWidth />
                )}
              />
                : null}

              </div>
              
              <div className="loginLink">
                <div>{this.props.userName}</div>
                <Button color="inherit" onClick={this.onClickLogout}>{this.props.isLogged?"Logout":"Login"}</Button>
              </div>
              
            </Toolbar>
          </AppBar>
          <div className="Container">
          {this.props.isLogged?Sidebar:null}
          {this.props.isLogged?<Redirect to={this.props.activeURI}/>:<Redirect to="/Login"/>}
          <Switch>
            <Route path="/" exact component={Homepage} />
            <Route path="/Login" exact component={Login} />
            <Route path="/Home" exact component={Homepage} />
            <Route path="/View" exact component={View} />
            <Route path="*" component={View404} />
          </Switch>
          {!this.props.fullLoad && this.props.isLogged? <div className="loader-wrapper"><div className="loader">Data Loading please wait...</div></div> : null}
          </div>
          <Footer></Footer>
        </div>
      </BrowserRouter>
    );
  }
}

const mapStateToProps = (state) => {    
  return {  
    presentationMode : state.appReducer.presentationMode,
    nightMode : state.appReducer.nightMode, 
    isLogged : state.apiReducer.isLogged,
    activeURI : state.appReducer.activeURI,
    clientList : state.apiReducer.clientList,
    userName : state.apiReducer.username,
    menuList : state.apiReducer.menuList,
    fullScope : state.apiReducer.fullScopeData,
    fullLoad : state.appReducer.fullLoad,
    formatedData:state.apiReducer.formatedData,
  } 
}
const mapDispatchToProps = (dispatch) => {
  return {
    openSession: (props) => dispatch(repositoryActions.openSession(props)),
    toggleSidebar: (props) => dispatch(sidebarActions.toggleSidebar(props)),
    updateActiveMenu: (uri) => dispatch(repositoryActions.updateActiveMenu(uri)),
    updateActiveURI: (uri) => dispatch(repositoryActions.updateActiveURI(uri)),
    logoutReturn: () => dispatch(repositoryActions.logoutReturn()),
    changeClientActive:(data)=>dispatch(repositoryActions.changeClientActive(data)),
    fullScopeData:(data)=>dispatch(repositoryActions.fullScopeData(data)),
  } 
} 

export default connect(mapStateToProps, mapDispatchToProps)(App);
